import { render, staticRenderFns } from "./ExcludeFeatureWrapper.vue?vue&type=template&id=0e15ebe2&"
import script from "./ExcludeFeatureWrapper.vue?vue&type=script&lang=js&"
export * from "./ExcludeFeatureWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports